import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-steady',
  templateUrl: './icon-steady.component.html',
  styleUrls: ['./icon-steady.component.scss']
})
export class IconSteadyComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
